import { can, cannot, isLicensedTo } from '@/general'

export default {
  methods: {
    can,
    cannot,
    isLicensedTo,
  }
}
